import Utils from './utils'
import * as keys from './keys'
import ProductConstants from 'constants/ProductConstants';

const formObserver = (formRef, props) => {

    formRef.$('policy-term').observe({
        key: 'value',
        call: ({ field }) => {
            // handle PPT condition
            let pptList = Utils.generatePPTList(formRef.$("plan-option").value.id, field.value.id)
            formRef.$("premium-paying-term").set("extra", {
                ...formRef.$("premium-paying-term").extra,
                optionList: pptList,
            });

            if (Number(formRef.$("plan-option").value.id) == 1) {
                if (Number(field.value.id) !== 15 && formRef.$("premium-paying-term").value.id === 5 ) {
                    formRef.$("premium-paying-term").set("value", pptList[pptList.length - 1])
                } else if (Number(field.value.id) === 15) {
                    formRef.$("premium-paying-term").set("value", pptList[pptList.length - 1])
                }
            } else if (Number(formRef.$("plan-option").value.id) == 2) {

                if (Number(field.value.id) !== 15) {
                    formRef.$("premium-paying-term").set("value", pptList[pptList.length - 1])
                } else if (Number(field.value.id) == 15 && (formRef.$("premium-paying-term").value.id != 5)) {
                    formRef.$("premium-paying-term").set("value", pptList[pptList.length - 1])
                }
            }
           
            // handled ASB start year 1
            Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name)
            // handled Preponement start end year 1
            Utils.handlePreponementStartYearOneConditions(formRef)

            let requestData = {
                PR_PT: field.value.id,
                PR_PPT: formRef.$("premium-paying-term").value.id,
                ASB_STARTPOLICYYEAR_1: formRef.$("asb-start-policy-year-(1st-opt-in)").value.id,
                ASB_ENDPOLICYYEAR_1: formRef.$("asb-end-policy-year-(1st-opt-in)").value.id,
                PFI_STARTPOLICYYEAR_1: formRef.$("pfi-start-policy-year-(1st-opt-in)").value.id,
                PFI_ENDPOLICYYEAR_1: formRef.$("pfi-end-policy-year-(1st-opt-in)").value.id,
            }

            Utils.updateBi(keys.PR_PT, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('premium-paying-term').observe({
        key: 'value',
        call: ({ field }) => {

            if (Number(field.value.id) == 5) {
                formRef.$("premium-break-benefit").set("value", { label: 'No', id: 4 },)
                formRef.$("premium-break-benefit").set("disabled", true);
                formRef.$("sum-assured-on-death-multiple").set("value", { label: '7', id: 7 },)
                formRef.$("sum-assured-on-death-multiple").set("disabled", true);
            } else {
                formRef.$("sum-assured-on-death-multiple").set("disabled", false);
                formRef.$("premium-break-benefit").set("disabled", false);
            }

            // handled ASB start year 1
            Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name)
            // handled Preponement start end year 1
            Utils.handlePreponementStartYearOneConditions(formRef)

            let requestData = {
                PR_PPT: field.value.id,
                PR_SAMF: formRef.$("sum-assured-on-death-multiple").value.id,
                PREMIUMBREAKBENEFIT : formRef.$("premium-break-benefit").value.id,
                PFI_STARTPOLICYYEAR_1: formRef.$("pfi-start-policy-year-(1st-opt-in)").value.id,
                PFI_ENDPOLICYYEAR_1: formRef.$("pfi-end-policy-year-(1st-opt-in)").value.id,
            }

            Utils.updateBi(keys.PR_PPT, requestData, props.data.product_id, formRef, props)
        },
    })

    formRef.$('premium-paying-frequency').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.INOUT_MODE, field.value.id, props.data.product_id, formRef, props)
        }
    })

    formRef.$('income-benefit-payout-frequency').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.INCOMEBENEFITPAYOUTFREQUENCY, field.value.id, props.data.product_id, formRef, props)
        }
    })

    formRef.$('plan-option').observe({
        key: 'value',
        call: ({ field }) => {
            // handled PPT condition
            let pptList = Utils.generatePPTList(field.value.id, formRef.$("policy-term").value.id)
            formRef.$("premium-paying-term").set("extra", {
                ...formRef.$("premium-paying-term").extra,
                optionList: pptList,
            });

            if (field.value.id === 1 && formRef.$("premium-paying-term").value.id == 5) {
                formRef.$("premium-paying-term").set("value", pptList[pptList.length - 1])
            }

            // handled ASB start year 1
            if(props.data.product_name !== ProductConstants.BHARAT_SAVINGS_STAR_LUMPSUM || 
                props.data.product_name !== ProductConstants.POS_BHARAT_SAVINGS_STAR_LUMPSUM) {
                    Utils.handleASBFirstStartEndCondition(formRef, 6)
                    formRef.$("accrual-of-survival-benefits").set("value", { label: 'No', id: 6 })
            } else {
                Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name)
            }
            // Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name)
            
            let requestData = {
                PLANOPTION: field.value.id,
                PR_PPT: formRef.$("premium-paying-term").value.id,
                ASB_STARTPOLICYYEAR_1: formRef.$("asb-start-policy-year-(1st-opt-in)").value.id
            }

            Utils.updateBi(keys.PLANOPTION, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('premium-break-benefit').observe({
        key: 'value',
        call: ({ field }) => {
            let requestData = {
                PREMIUMBREAKBENEFIT : field.value.id,
                PR_PPT: formRef.$("premium-paying-term").value.id
            }

            Utils.updateBi(keys.PREMIUMBREAKBENEFIT, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('accrual-of-survival-benefits').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbCondition(formRef, field.value.id)
            let asbStartYear1 = ""
            let asbEndYear1 = ""
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2= ""
            let asb3= ""
            let asbStartYear3= ""
            let asbEndYear3= ""
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            if(field.value.id === 5) {
                Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name)
                if(formRef.$('asb-start-policy-year-(1st-opt-in)').value) {
                    asbStartYear1 = formRef.$('asb-start-policy-year-(1st-opt-in)').value.id
                }
                if(formRef.$('asb-end-policy-year-(1st-opt-in)').value) {
                    asbEndYear1 = formRef.$('asb-end-policy-year-(1st-opt-in)').value.id
                }
                asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
                if(formRef.$('asb-start-policy-year-(2nd-opt-in)').value) {
                    asbStartYear2 = formRef.$('asb-start-policy-year-(2nd-opt-in)').value.id
                } 
                if(formRef.$('asb-end-policy-year-(2nd-opt-in)').value) {
                    asbEndYear2 = formRef.$('asb-end-policy-year-(2nd-opt-in)').value.id
                }
                asb3 =  formRef.$('accrual-of-survival-benefits-year-3').value.id
                if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-policy-year-(3rd-opt-in)').value.id
                }
                preponement1 = formRef.$('preponement-of-future-income').value.id
                if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                    preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                    preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
                }
                preponement2 = formRef.$('preponement-year-2').value.id
                if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                    preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                    preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
                }
                preponement3 = formRef.$('preponement-year-3').value.id
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
            }
            let requestData = {
                asb1 : field.value.id,
                asbStartYear1,
                asbEndYear1,
                asb2,
                asbStartYear2, 
                asbEndYear2,
                asb3,
                asbStartYear3, 
                asbEndYear3,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-start-policy-year-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2= ""
            let asb3= ""
            let asbStartYear3= ""
            let asbEndYear3= ""
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits').value.id)
            let asbEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-policy-year-(1st-opt-in)").extra.optionList, formRef.$("asb-end-policy-year-(1st-opt-in)").extra.preDefinedOptList)
            formRef.$("asb-end-policy-year-(1st-opt-in)").set("extra", {
                ...formRef.$("asb-end-policy-year-(1st-opt-in)").extra,
                optionList: asbEndYearOneList,
            });
            let selectedAsbEndYearOne = asbEndYearOneList.some((item) =>item.id === formRef.$("asb-end-policy-year-(1st-opt-in)").value?.id);
            if (!selectedAsbEndYearOne) {
                let optData = asbEndYearOneList.find((item)=> item.label === field.value.label)
                formRef
                    .$("asb-end-policy-year-(1st-opt-in)")
                    .set("value", optData);
            }
            if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) - 1 || Number(formRef.$("asb-end-policy-year-(1st-opt-in)").value.label) === Number(formRef.$("policy-term").value.label) - 1) {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
            }
            asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
            if(formRef.$('asb-start-policy-year-(2nd-opt-in)').value) {
                asbStartYear2 = formRef.$('asb-start-policy-year-(2nd-opt-in)').value.id
            } 
            if(formRef.$('asb-end-policy-year-(2nd-opt-in)').value) {
                asbEndYear2 = formRef.$('asb-end-policy-year-(2nd-opt-in)').value.id
            }
            asb3 =  formRef.$('accrual-of-survival-benefits-year-3').value.id
            if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-policy-year-(3rd-opt-in)').value.id
            }
            preponement1 = formRef.$('preponement-of-future-income').value.id
            if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbStart1: field.value.id,
                asbEnd1: formRef.$("asb-end-policy-year-(1st-opt-in)").value.id,
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-end-policy-year-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2= ""
            let asb3= ""
            let asbStartYear3= ""
            let asbEndYear3= ""
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits').value.id)
            asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
            if(Number(field.value.label) >= Number(formRef.$("policy-term").value.label) - 2 || Number(formRef.$("asb-start-policy-year-(1st-opt-in)").value.label) === Number(formRef.$("policy-term").value.label) - 1) {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
            }
            if(formRef.$('asb-start-policy-year-(2nd-opt-in)').value) {
                asbStartYear2 = formRef.$('asb-start-policy-year-(2nd-opt-in)').value.id
            } 
            if(formRef.$('asb-end-policy-year-(2nd-opt-in)').value) {
                asbEndYear2 = formRef.$('asb-end-policy-year-(2nd-opt-in)').value.id
            }
            asb3 =  formRef.$('accrual-of-survival-benefits-year-3').value.id
            if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-policy-year-(3rd-opt-in)').value.id
            }
            preponement1 = formRef.$('preponement-of-future-income').value.id
            if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbEnd1: field.value.id || "",
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('accrual-of-survival-benefits-year-2').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbTwoCondition(formRef, field.value.id)
            let asbStartYear2 = ""
            let asbEndYear2= ""
            let asb3= ""
            let asbStartYear3= ""
            let asbEndYear3= ""
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            if(field.value.id === 87) {
                Utils.handleASBTwostartPolicyOneConditions(formRef)
                if(formRef.$('asb-start-policy-year-(2nd-opt-in)').value) {
                    asbStartYear2 = formRef.$('asb-start-policy-year-(2nd-opt-in)').value.id
                } 
                if(formRef.$('asb-end-policy-year-(2nd-opt-in)').value) {
                    asbEndYear2 = formRef.$('asb-end-policy-year-(2nd-opt-in)').value.id
                }
                asb3 =  formRef.$('accrual-of-survival-benefits-year-3').value.id
                if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-policy-year-(3rd-opt-in)').value.id
                }
                preponement1 = formRef.$('preponement-of-future-income').value.id
                if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                    preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                    preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
                }
                preponement2 = formRef.$('preponement-year-2').value.id
                if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                    preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                    preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
                }
                preponement3 = formRef.$('preponement-year-3').value.id
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
            }
            let requestData = {
                asb2 : field.value.id,
                asbStartYear2, 
                asbEndYear2,
                asb3,
                asbStartYear3, 
                asbEndYear3,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-start-policy-year-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb3= ""
            let asbStartYear3= ""
            let asbEndYear3= ""
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
            let asbTwoEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-policy-year-(2nd-opt-in)").extra.optionList, formRef.$("asb-end-policy-year-(2nd-opt-in)").extra.preDefinedOptList);
            formRef.$("asb-end-policy-year-(2nd-opt-in)").set("extra", {
                ...formRef.$("asb-end-policy-year-(2nd-opt-in)").extra,
                optionList: asbTwoEndYearOneList,
            });
            let selectedAsbTwoEndYearOne = asbTwoEndYearOneList.some((item) =>item.id === formRef.$("asb-end-policy-year-(2nd-opt-in)").value?.id);
            if (!selectedAsbTwoEndYearOne) {
                let optData = asbTwoEndYearOneList.find((item)=> item.label === field.value.label)
                formRef
                .$("asb-end-policy-year-(2nd-opt-in)")
                .set("value", optData);
            }
            if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) - 1 || Number(formRef.$("asb-end-policy-year-(2nd-opt-in)").value.label) === Number(formRef.$("policy-term").value.label) - 1) {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
            }
            asb3 =  formRef.$('accrual-of-survival-benefits-year-3').value.id
            if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-policy-year-(3rd-opt-in)').value.id
            }
            preponement1 = formRef.$('preponement-of-future-income').value.id
            if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbStartYear2: field.value.id,
                asbEndYear2: formRef.$("asb-end-policy-year-(2nd-opt-in)").value.id,
                asb3,
                asbStartYear3,
                asbEndYear3,
                asbEndYear3,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-end-policy-year-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb3= ""
            let asbStartYear3= ""
            let asbEndYear3= ""
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
            asb3 =  formRef.$('accrual-of-survival-benefits-year-3').value.id
            if(Number(field.value.label) >= Number(formRef.$("policy-term").value.label) - 2 || Number(formRef.$("asb-start-policy-year-(2nd-opt-in)").value.label) === Number(formRef.$("policy-term").value.label) - 1) {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
            }
            if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-policy-year-(3rd-opt-in)').value.id
            }
            preponement1 = formRef.$('preponement-of-future-income').value.id
            if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbEndYear2: field.value.id || "",
                asb3,
                asbStartYear3,
                asbEndYear3,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('accrual-of-survival-benefits-year-3').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbThreeCondition(formRef, field.value.id)
            let asbStartYear3= ""
            let asbEndYear3= ""
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            if(field.value.id === 165) {
                Utils.handleASBThreestartPolicyOneConditions(formRef)
                if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-policy-year-(3rd-opt-in)').value.id
                }
                preponement1 = formRef.$('preponement-of-future-income').value.id
                if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                    preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                    preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
                }
                preponement2 = formRef.$('preponement-year-2').value.id
                if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                    preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                    preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
                }
                preponement3 = formRef.$('preponement-year-3').value.id
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
            }
            let requestData = {
                asb3 : field.value.id,
                asbStartYear3, 
                asbEndYear3,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-start-policy-year-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            let asbThreeEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-policy-year-(3rd-opt-in)").extra.optionList, formRef.$("asb-end-policy-year-(3rd-opt-in)").extra.preDefinedOptList);
            formRef.$("asb-end-policy-year-(3rd-opt-in)").set("extra", {
                ...formRef.$("asb-end-policy-year-(3rd-opt-in)").extra,
                optionList: asbThreeEndYearOneList,
            });
            let selectedAsbThreeEndYearOne = asbThreeEndYearOneList.some((item) =>item.id === formRef.$("asb-end-policy-year-(3rd-opt-in)").value?.id);
            if (!selectedAsbThreeEndYearOne) {
                let optData = asbThreeEndYearOneList.find((item)=> item.label === field.value.label)
                formRef
                .$("asb-end-policy-year-(3rd-opt-in)")
                .set("value", optData);
            }
            // if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) - 1 || Number(formRef.$("asb-end-policy-year-(3rd-opt-in)").value.label) === Number(formRef.$("policy-term").value.label) - 1) {
            //     formRef.$('preponement-of-future-income').set("disabled", true)
            // } else {
            //     formRef.$('preponement-of-future-income').set("disabled", false)
            // }
            preponement1 = formRef.$('preponement-of-future-income').value.id
            if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbStartYear3: field.value.id || "",
                asbEndYear3: formRef.$("asb-end-policy-year-(3rd-opt-in)").value.id,
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('asb-end-policy-year-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let preponement1= ""
            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            // if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) - 1 || Number(formRef.$("asb-start-policy-year-(3rd-opt-in)").value.label) === Number(formRef.$("policy-term").value.label) - 1) {
            //     formRef.$('preponement-of-future-income').set("disabled", true)
            // } else {
            //     formRef.$('preponement-of-future-income').set("disabled", false)
            // }
            preponement1 = formRef.$('preponement-of-future-income').value.id
            if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbEndYear3: field.value.id || "",
                preponement1,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3,
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('preponement-of-future-income').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handlePreponementOneCondition(formRef, field.value.id)

            let preponementStartYear1 = ""
            let preponementEndYear1 = ""
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""

            if(field.value.id === 239) {
                Utils.handlePreponementStartYearOneConditions(formRef)
                if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value) {
                    preponementStartYear1 = formRef.$('pfi-start-policy-year-(1st-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value) {
                    preponementEndYear1 = formRef.$('pfi-end-policy-year-(1st-opt-in)').value.id
                }
                preponement2 = formRef.$('preponement-year-2').value.id
                if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                    preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                    preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
                }
                preponement3 = formRef.$('preponement-year-3').value.id
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
            }

            let requestData = {
                preponement1 : field.value.id,
                preponementStartYear1,
                preponementEndYear1,
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3
            }
            Utils.updateBi(keys.PREPONEMENTOFFUTUREINCOME_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('pfi-start-policy-year-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""

            Utils.handlePreponementFirstStartEndCondition(formRef, formRef.$("preponement-of-future-income").value.id)
            let endYearOneList = Utils.fetchPreponementEndYearList(field.value.label, formRef.$("policy-term").value.id, formRef.$("pfi-end-policy-year-(1st-opt-in)").extra.preDefinedOptList)
            formRef.$("pfi-end-policy-year-(1st-opt-in)").set("extra", {
                ...formRef.$("pfi-end-policy-year-(1st-opt-in)").extra,
                optionList: endYearOneList,
            });
            let selectedEndYearOne = endYearOneList.some((item) =>item.id === formRef.$("pfi-end-policy-year-(1st-opt-in)").value?.id);
            if (!selectedEndYearOne) {
            let optData = endYearOneList.find((item)=> item.label === field.value.label)
                formRef
                    .$("pfi-end-policy-year-(1st-opt-in)")
                    .set("value", optData);
            }
            if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) || Number(formRef.$("pfi-end-policy-year-(1st-opt-in)").value.label) === Number(formRef.$("policy-term").value.label)) {
                formRef.$('preponement-year-2').set("disabled", true)
            } else {
                formRef.$('preponement-year-2').set("disabled", false)
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }

            let requestData = {
                preponementStart1: field.value.id || "",
                preponementEnd1: formRef.$("pfi-end-policy-year-(1st-opt-in)").value.id || "",
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3
            }
            Utils.updateBi(keys.PFI_STARTPOLICYYEAR_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('pfi-end-policy-year-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let preponement2 = ""
            let preponementStartYear2 = ""
            let preponementEndYear2 = ""
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            Utils.handlePreponementFirstStartEndCondition(formRef, formRef.$("preponement-of-future-income").value.id)
            if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) || Number(formRef.$("pfi-start-policy-year-(1st-opt-in)").value.label) === Number(formRef.$("policy-term").value.label)) {
                formRef.$('preponement-year-2').set("disabled", true)
            } else {
                formRef.$('preponement-year-2').set("disabled", false)
            }
            preponement2 = formRef.$('preponement-year-2').value.id
            if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
            }
            if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                preponementEnd1: field.value.id || "",
                preponement2,
                preponementStartYear2,
                preponementEndYear2,
                preponement3,
                preponementStartYear3,
                preponementEndYear3
            }
            Utils.updateBi(keys.PFI_ENDPOLICYYEAR_1, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('preponement-year-2').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handlePreponementTwoCondition(formRef, field.value.id)
            let preponementStartYear2 = ""
            let preponementEndYear2= ""
            let preponement3= ""
            let preponementStartYear3= ""
            let preponementEndYear3= ""
            if(field.value.id === 309) {
                Utils.handlePreponementTwostartPolicyOneConditions(formRef)
                if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value) {
                    preponementStartYear2 = formRef.$('pfi-start-policy-year-(2nd-opt-in)').value.id
                }
                if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value) {
                    preponementEndYear2 = formRef.$('pfi-end-policy-year-(2nd-opt-in)').value.id
                }
                preponement3 = formRef.$('preponement-year-3').value.id
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
            }
            let requestData = {
                preponement2 : field.value.id,
                preponementStartYear2, 
                preponementEndYear2,
                preponement3,
                preponementStartYear3, 
                preponementEndYear3
            }
            Utils.updateBi(keys.PREPONEMENTOFFUTUREINCOME_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('pfi-start-policy-year-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            Utils.handlePreponementTwoStartEndCondition(formRef, formRef.$("preponement-year-2").value.id)
            let endYearOneList = Utils.fetchPreponementEndYearList(field.value.label, formRef.$("policy-term").value.id, formRef.$("pfi-end-policy-year-(2nd-opt-in)").extra.preDefinedOptList)
            formRef.$("pfi-end-policy-year-(2nd-opt-in)").set("extra", {
                ...formRef.$("pfi-end-policy-year-(2nd-opt-in)").extra,
                optionList: endYearOneList,
            });
            let selectedEndYearOne = endYearOneList.some((item) =>item.id === formRef.$("pfi-end-policy-year-(2nd-opt-in)").value?.id);
            if (!selectedEndYearOne) {
                let optData = endYearOneList.find((item)=> item.label === field.value.label)
                formRef
                    .$("pfi-end-policy-year-(2nd-opt-in)")
                    .set("value", optData);
            }
            if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) || Number(formRef.$("pfi-end-policy-year-(2nd-opt-in)").value.label) === Number(formRef.$("policy-term").value.label)) {
                formRef.$('preponement-year-3').set("disabled", true)
            } else {
                formRef.$('preponement-year-3').set("disabled", false)
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                preponementStart2: field.value.id || "",
                preponementEnd2: formRef.$("pfi-end-policy-year-(2nd-opt-in)").value.id || "",
                preponement3,
                preponementStartYear3,
                preponementEndYear3
            }
            Utils.updateBi(keys.PFI_STARTPOLICYYEAR_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('pfi-end-policy-year-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let preponement3 = ""
            let preponementStartYear3 = ""
            let preponementEndYear3 = ""
            Utils.handlePreponementTwoStartEndCondition(formRef, formRef.$("preponement-year-2").value.id)
            if(Number(field.value.label) === Number(formRef.$("policy-term").value.label) || Number(formRef.$("pfi-start-policy-year-(2nd-opt-in)").value.label) === Number(formRef.$("policy-term").value.label)) {
                formRef.$('preponement-year-3').set("disabled", true)
            } else {
                formRef.$('preponement-year-3').set("disabled", false)
            }
            preponement3 = formRef.$('preponement-year-3').value.id
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
            }
            let requestData = {
                preponementEnd2: field.value.id || "",
                preponement3,
                preponementStartYear3,
                preponementEndYear3
            }
            Utils.updateBi(keys.PFI_ENDPOLICYYEAR_2, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('preponement-year-3').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handlePreponementThreeCondition(formRef, field.value.id)
            let preponementStartYear3= ""
            let preponementEndYear3= ""
            if(field.value.id === 375) {
                Utils.handlePreponementThreestartPolicyOneConditions(formRef)
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementStartYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
                if(formRef.$('pfi-start-policy-year-(3rd-opt-in)').value) {
                    preponementEndYear3 = formRef.$('pfi-start-policy-year-(3rd-opt-in)').value.id
                }
            }
            let requestData = {
                preponement3: field.value.id,
                preponementStartYear3, 
                preponementEndYear3
            }
            Utils.updateBi(keys.PREPONEMENTOFFUTUREINCOME_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('pfi-start-policy-year-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let endYearOneList = Utils.fetchPreponementEndYearList(field.value.label, formRef.$("policy-term").value.id, formRef.$("pfi-end-policy-year-(3rd-opt-in)").extra.preDefinedOptList)
            formRef.$("pfi-end-policy-year-(3rd-opt-in)").set("extra", {
                ...formRef.$("pfi-end-policy-year-(3rd-opt-in)").extra,
                optionList: endYearOneList,
            });
            let selectedEndYear = endYearOneList.some((item) =>item.id === formRef.$("pfi-end-policy-year-(3rd-opt-in)").value?.id);
            if (!selectedEndYear) {
                let optData = endYearOneList.find((item)=> item.label === field.value.label)
                formRef
                    .$("pfi-end-policy-year-(3rd-opt-in)")
                    .set("value", optData);
            }
            let requestData = {
                preponementStart3: field.value.id || "",
                preponementEnd3: formRef.$("pfi-end-policy-year-(3rd-opt-in)").value.id || ""
            }
            Utils.updateBi(keys.PFI_STARTPOLICYYEAR_3, requestData, props.data.product_id, formRef, props)
        }
    })

    formRef.$('pfi-end-policy-year-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PFI_ENDPOLICYYEAR_3, field.value.id ? field.value.id : "", props.data.product_id, formRef, props)
        }
    })

    formRef.$('auto-renewal-booster').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.AUTORENEWALBOOSTER, field.value.id, props.data.product_id, formRef, props)
        }
    })

    formRef.$('sum-assured-on-death-multiple').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.PR_SAMF, field.value.id, props.data.product_id, formRef, props)
        }
    })

    formRef.$('ADB').observe({
        key: 'value',
        call: ({ field }) => {
            let adbValue = formRef.$('ADB-dropdown').value
            Utils.updateBi(keys.ADB_RIDER, adbValue, props.data.product_id, formRef, props)
        }
    })

    formRef.$('ATPDRider').observe({
        key: 'value',
        call: ({ field }) => {
            let atpdValue = formRef.$('ATPDRider-dropdown').value
            Utils.updateBi(keys.ATPD_RIDER, atpdValue, props.data.product_id, formRef, props)
        }
    })

    formRef.$('CriticalIllnessRider').observe({
        key: 'value',
        call: ({ field }) => {
            let criticalIllness = formRef.$('CriticalIllnessRider-dropdown').value
            Utils.updateBi(keys.Critical_ILLNESS_RIDER, criticalIllness, props.data.product_id, formRef, props)
        }
    })

    formRef.$('PayorWaiverBenefitRider-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PWB_RIDER, field.value.id, props.data.product_id, formRef, props)
        }
    })
}
export default formObserver